import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../Utility/constants";
import Footer from "../common/Footer";
import ExamHeadHeader from "../common/ExamHeadHeader";

const ExamHeadDashboard = () => {

  return (
    <>
      <ExamHeadHeader />
     
      <div className="container mt-5 mb-5">
      <h2>Welcome to Exam Head's Panel </h2>
        {/* <StudentPersonalDetailsList
          data={data}
          onEdit={handleEdit}
          onView={handleView}
          onOtherDetailsEdit={handleOtherDetailsEdit}         
        />        
        {showEditModal && (
          <EditStudentPersonalDetailsModal
            show={showEditModal}
            handleClose={() => setShowEditModal(false)}
            handleSubmit={handleSubmit}
            editItem={editItem}
            setEditItem={setEditItem}
          />
        )}
        {showOtherDetailsEditModal && (
          <StudentOtherDetailsModal
            selectedStudentId={selectedStudentId}
            schoolId={schoolId}
            showOtherDetails={showOtherDetailsEditModal}
            handleCloseOtherDetails={() => setShowOtherDetailsModal(false)}
            handleSubmitOtherDetails={handleSubmitOtherDetails}
          />
        )}
        {showDetailsModal && (
          <StudentDetail_Modal
            show={showDetailsModal}
            handleDetailsClose={() => setShowDetailsModal(false)}
            studentDetails={studentDetails}
          />
        )}        */}
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default ExamHeadDashboard;
